import React, { Fragment, useState, useEffect } from 'react';
import {
    Grid,
    Box,
    Typography,
    TableContainer,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    InputAdornment,
    tableCellClasses,
    Paper,
    IconButton,
} from '@mui/material';
import ClientServices from 'services/Client';
import VehicleBookingServices from 'services/VehicleBooking';
import InputField from 'components/Input';
import DatePicker from 'components/DatePicker';
import { PrimaryButton } from 'components/Buttons';
import Colors from 'assets/Style/Colors';
import { SearchIcon, FontFamily } from 'assets';
import SelectField from 'components/Select';
import { useForm } from "react-hook-form";
import styled from "@emotion/styled";
import { makeStyles } from "@mui/styles";
import moment from 'moment';
import { Delete } from "@mui/icons-material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ErrorToaster, SuccessToaster } from 'components/Toaster';



const Row = styled(TableRow)({ border: 0 });
const Cell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        fontSize: 14,
        fontFamily: FontFamily.NunitoRegular,
        border: 0,
        textAlign: "center",
        whiteSpace: "nowrap",
        background: Colors.primary,
        color: Colors.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        fontFamily: FontFamily.NunitoRegular,
        textAlign: "center",
        textWrap: "nowrap",
        padding: "5px !important",
        ".MuiBox-root": {
            display: "flex",
            gap: "6px",
            alignItems: "center",
            justifyContent: "center",
            ".MuiBox-root": {
                cursor: "pointer",
            },
        },
        svg: {
            width: "auto",
            height: "24px",
        },
        ".MuiTypography-root": {
            textTransform: "capitalize",
            fontFamily: FontFamily.NunitoRegular,
            textWrap: "nowrap",
        },
        ".MuiButtonBase-root": {
            padding: "8px",
            width: "28px",
            height: "28px",
        },
    },
}));

const useStyles = makeStyles({
    loaderWrap: {
        display: "flex",
        height: 100,
    },
});

// const useStyles = {
//   tableHeader: {
//     backgroundColor: '#f5f5f5',
//     fontWeight: 'bold',
//   },
//   tableCell: {
//     textAlign: 'center',
//   },
//   notesTextArea: {
//     width: '100%',
//     marginTop: '20px',
//   },
// };

const UpdateSpecialDiscount = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { id } = useParams();
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedDate, setSelectedDate] = useState(null);
    const [vehicles, setVehicles] = useState([]);
    const [selectedVin, setSelectedVin] = useState('');
    const [rows, setRows] = useState([]);
    const [notes, setNotes] = useState('');
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        notes: '',
        date: '',
        vehicles: [],
    });
    const { register, formState: { errors }, getValues: getValues1, } = useForm();
    const [isSearching, setIsSearching] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [selectedRows, setSelectedRows] = useState(
        location.state?.selectedRows || []
    );
    const [filters, setFilters] = useState({});
    const [pageLimit, setPageLimit] = useState(20);
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedBookingCustomer, setSelectedBookingCustomer] = useState(null);
    const [bookingCustomers, setBookingCustomers] = useState([]);
    const [referenceNo, setReferenceNo] = useState('');
    const [originalData, setOriginalData] = useState([]); // Store the original unfiltered data
    const [filteredRows, setFilteredRows] = useState([]); // This will hold the filtered results

    const UpdateSpecialDiscount = async () => {

        const vehiclesData = rows.map((row) => ({
            booking_id: row?.booking?.id || row.booking_id || row.id,
            discount: row?.discount,
            customer_name: row?.booking?.customer?.name,
        }));

        const finalData = {
            date: formData.date || selectedDate || new Date(),
            special_discount_id: id,
            totalDiscount: totalDiscount,
            credit_customer: selectedBookingCustomer?.id || rows?.[0]?.creditCustomer?.id,
            reference_no: id,
            vehicles: vehiclesData,
            notes: formData?.notes ?? '',
        };


        console.log(finalData, 'params')

        try {
            setLoading(true);
            const response = await ClientServices.updateSpecialDiscount(finalData);

            console.log("Update API Response", response);
            navigate('/special-discount-list')


            if (response.success) {
                SuccessToaster('Data updated successfully!');
            }
        } catch (error) {
            console.error('Error updating special discount:', error);
            ErrorToaster(error);
        } finally {
            setLoading(false);
        }
    };


    const getSpecialDiscountDetails = async () => {
        try {

            let params = { reference_no: id };
            const { data } = await ClientServices.specialDiscountDetails(params);

            setOriginalData(data?.detail?.rows);
            setFilteredRows(data?.detail?.rows);

            setRows(data?.detail?.rows);
            const apiNotes = data?.detail?.rows?.[0]?.notes ?? "";
            setFormData(prev => ({ ...prev, notes: apiNotes }));

            const apiDate = data?.detail?.rows?.[0]?.date;
            if (apiDate) {
                setSelectedDate(moment(apiDate).format('YYYY-MM-DD'));
            }
        } catch (error) {
            console.log(error);
        }
    };

    console.log(originalData, 'originaldata')

    const getAllVehicles = async () => {
        try {
            const { data } = await ClientServices.getSLPVehicles();
            console.log("data", data)
            setVehicles(data.vehicles);
        } catch (error) {
            console.log(error);
        }
    };



    const handleDiscountSChange = (id, value) => {

        const updatedRows = rows.map((row) =>
            row.id === id ? {
                ...row,
                discount: value,
                total: (parseFloat(value) || 0)

            } : row
        );
        setRows(updatedRows);
        // const updatedRows = rows.map((row) =>
        //     row.id === id ? { ...row, discount: value, } : row
        // );
        // setRows(updatedRows);
    };


    const handleDelete = (vin) => {
        const updatedRows = rows.filter((row) => row.booking?.vin !== vin);
        setRows(updatedRows);
    };

    const totalDiscount = rows.reduce((acc, row) => acc + (parseFloat(row.discount) || 0), 0);


    const getBookingCustomers = async (search) => {
        try {
            let params = {
                page: 1,
                limit: 50,
                search: search,
            };
            const { data } = await VehicleBookingServices.getBookingCustomers(params);
            setBookingCustomers(
                data?.filters.map((item) => {
                    return { id: item?.customer_id, name: item?.customer_name };
                })
            );
        } catch (error) {
            ErrorToaster(error);
        }
    };

    const getAllSLPVehicles = async (page, limit, filter) => {
        try {
            const Page = page || currentPage;
            const Limit = limit || pageLimit;
            const Filter = { ...filters, ...filter };

            const params = {
                page: Page,
                limit: Limit,
                ...Filter,
            };

            const { data } = await ClientServices.getSLPVehicles(params);

            if (filter?.search) {
                const matchedVehicle = data.vehicles.find(vehicle => vehicle.vin === filter.search);
                console.log("🔍 Matched vehicle:", matchedVehicle);

                if (matchedVehicle) {
                    const alreadyExists = rows.find(row => row.booking?.vin === matchedVehicle.vin);

                    if (!alreadyExists) {
                        const newRow = {
                            id: matchedVehicle.id,
                            buyer_id: matchedVehicle.buyer_id,
                            discount: 0,
                            total: 0,
                            booking: {
                                id: matchedVehicle.booking_id,
                                vin: matchedVehicle.vin,
                                lot_number: matchedVehicle.lot_number,
                                customer: { name: matchedVehicle.customer?.name },
                                veh_model: { name: matchedVehicle.veh_model?.name },
                                veh_make: { name: matchedVehicle.veh_make?.name },
                            }
                        };

                        setRows(prev => [...prev, newRow]);
                    } else {
                        ErrorToaster("This VIN is already added.");
                    }
                } else {
                    ErrorToaster("VIN not found.");
                }
            } else {
                setVehicles(data.vehicles);
            }

            setCurrentPage(Page);
            setPageLimit(Limit);
            setFilters(Filter);
        } catch (error) {
            console.error("getAllSLPVehicles error:", error);
        }
    };


    // const getAllSLPVehicles = async (page, limit, filter) => {
    //     try {
    //         const Page = page || currentPage;
    //         const Limit = limit || pageLimit;
    //         const Filter = { ...filters, ...filter };

    //         const params = {
    //             page: Page,
    //             limit: Limit,
    //             ...Filter,
    //         };

    //         const { data } = await ClientServices.getSLPVehicles(params);

    //         if (filter?.search) {
    //             const matchedVehicle = data.vehicles.find(vehicle => vehicle.vin === filter.search);
    //             console.log("🔍 Matched vehicle:", matchedVehicle);

    //             if (matchedVehicle) {
    //                 const alreadyExists = rows.find(row => row.booking?.vin === matchedVehicle.vin);


    //                 if (!alreadyExists) {
    //                     const isFirstRow = rows.length === 0;
    //                     const isSameBuyer = !isFirstRow && rows[0]?.booking?.buyer_id === matchedVehicle.buyer_id;

    //                     if (isFirstRow || isSameBuyer) {
    //                         const newRow = {
    //                             id: matchedVehicle.id,
    //                             buyer_id: matchedVehicle.buyer_id,
    //                             discount: 0,
    //                             total: 0,
    //                             booking: {
    //                                 id: matchedVehicle.booking_id,
    //                                 vin: matchedVehicle.vin,
    //                                 lot_number: matchedVehicle.lot_number,
    //                                 customer: { name: matchedVehicle.customer?.name },
    //                                 veh_model: { name: matchedVehicle.veh_model?.name },
    //                                 veh_make: { name: matchedVehicle.veh_make?.name },
    //                             }
    //                         };

    //                         setRows(prev => [...prev, newRow]);
    //                     } else {
    //                         ErrorToaster("Vehicles with a different buyer ID cannot be added.");
    //                     }
    //                 } else {
    //                     ErrorToaster("This VIN is already added.");
    //                 }
    //             } else {
    //                 ErrorToaster("VIN not found.");
    //             }
    //         } else {
    //             setVehicles(data.vehicles);
    //         }

    //         setCurrentPage(Page);
    //         setPageLimit(Limit);
    //         setFilters(Filter);
    //     } catch (error) {
    //         console.error("getAllSLPVehicles error:", error);
    //     }
    // };

    const handleFilter = async (data) => {
        if (!data) {
            return;
        }

        if (isSearching) return;


        setIsSearching(true);
        try {
            await getAllSLPVehicles(1, "", data);

        } catch (err) {
            console.error("Search failed:", err);
        } finally {
            setIsSearching(false);
        }
    }



    useEffect(() => {
        getBookingCustomers();
        getSpecialDiscountDetails();
        getAllVehicles();
        getAllSLPVehicles();

    }, []);


    console.log(rows, 'rows')
    return (
        <Fragment>


            <Grid container spacing={1} alignItems={'center'} justifyContent={'center'}>
                <Grid item xs={12} sm={12} md={11}>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            mr: 4,
                            my: 4,
                        }}
                    >
                        <Typography
                            variant='h4'
                            sx={{
                                color: Colors.charcoalGrey,
                                fontFamily: FontFamily.NunitoRegular,
                            }}
                        >
                            Update Special Discount
                        </Typography>
                    </Box>
                </Grid>
                {/* Filters */}
                <Grid item md={11}>
                    <Box
                        sx={{
                            m: '10px 0 10px 0',
                            // p: '20px',
                            // bgcolor: Colors.feta,
                            // border: `1px solid ${Colors.iron}`,
                            // borderRadius: '9px',
                        }}
                    >
                        <Grid
                            container
                            spacing={2}
                            alignItems={'center'}
                            component={'form'}
                        >
                            <Grid item xs={12} sm={2.5} sx={{ marginTop: "5px" }}>
                                <InputField
                                    size={"small"}
                                    inputStyle={{ backgroundColor: "#f5f5f5" }}
                                    label={"Search"}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                    placeholder={"Search"}
                                    register={register("search")}
                                />

                            </Grid>
                            <Grid item xs={12} sm={2.5} >
                                <DatePicker
                                    size={'small'}
                                    label={'Select Date'}
                                    value={selectedDate ? moment(selectedDate).toDate() : new Date()}
                                    onChange={(date) =>
                                        setSelectedDate(moment(date).format('YYYY-MM-DD'))
                                    }
                                />
                            </Grid>

                            <Grid item xs={12} sm={2.5} sx={{ marginTop: '7px' }}>
                                <SelectField
                                    size={"small"}
                                    onSearch={(v) => getBookingCustomers(v)}
                                    label={"Credit To Customer"}
                                    options={bookingCustomers}
                                    selected={rows?.[0]?.creditCustomer?.name || selectedBookingCustomer}
                                    onSelect={(value) => {
                                        setSelectedBookingCustomer(value);
                                        handleFilter({ customer_id: value?.id });
                                    }}
                                    register={register("bookingCustomer")}
                                />
                            </Grid>
                            <Grid item xs={12} sm={2.5} sx={{ marginTop: "5px" }}>
                                <InputField
                                    size={"small"}
                                    // inputStyle={{ backgroundColor: "#f5f5f5" }}
                                    label={"Ref.No"}
                                    // InputProps={{
                                    //     startAdornment: (
                                    //         <InputAdornment position="start">
                                    //             <SearchIcon />
                                    //         </InputAdornment>
                                    //     ),
                                    // }}
                                    value={rows?.[0]?.reference_no || referenceNo}

                                    placeholder={'Ref.No'}
                                    register={register("refNo")}
                                    disabled={true}

                                />

                            </Grid>
                            <Grid item xs={12} md={2}>
                                <Box
                                    sx={{
                                        mt: "13px",
                                    }}
                                >
                                    <PrimaryButton onClick={() => {
                                        const searchVal = getValues1("search");
                                        if (searchVal) {
                                            handleFilter({ search: searchVal });
                                        }
                                    }} title="Search" />
                                </Box>
                            </Grid>

                        </Grid>
                    </Box>

                    <Box>
                        <TableContainer
                            component={Paper}
                            sx={{
                                boxShadow: "0px 8px 18px 0px #9B9B9B1A",
                                borderRadius: 2,
                                maxHeight: "calc(100vh - 330px)",
                                mt: 2,
                            }}
                            className="table-box"

                        >
                            <Table stickyHeader sx={{ minWidth: 500 }}>
                                <TableHead>
                                    <TableRow>
                                        <Cell>Customer Name</Cell>
                                        <Cell>VIN</Cell>
                                        <Cell>LOT</Cell>
                                        <Cell>Model/Make</Cell>
                                        <Cell sx={{ width: "10%" }}>Discount$</Cell>
                                        {/* <Cell>Notes</Cell> */}
                                        <Cell>Action</Cell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rows.length > 0 ? (
                                        <>
                                            {rows.map((row) => (
                                                <TableRow
                                                    key={row.id}
                                                    sx={{
                                                        bgcolor: rows.indexOf(row) % 2 !== 0 ? '#EFF8E7' : 'inherit',
                                                    }}
                                                >
                                                    <Cell>{row?.booking?.customer?.name}</Cell>
                                                    <Cell>{row?.booking?.vin}</Cell>
                                                    <Cell>{row?.booking?.lot_number}</Cell>
                                                    <Cell>{row?.booking?.veh_model?.name}{'-'}{row?.booking?.veh_make?.name}</Cell>
                                                    <Cell sx={{ width: "10%" }}>
                                                        <InputField
                                                            size="small"
                                                            type="number"
                                                            value={row.discount}
                                                            onInput={(e) => handleDiscountSChange(row.id, parseFloat(e.target.value))}
                                                        />
                                                    </Cell>
                                                    {/* <Cell>
                                                        <Box
                                                            component={"div"}
                                                            onClick={() => handleEditClick(row)}
                                                        >
                                                            <EditIcon />
                                                        </Box>
                                                    </Cell> */}
                                                    <Cell>
                                                        <IconButton onClick={() => handleDelete(row?.booking?.vin)} color="error">
                                                            <Delete />
                                                        </IconButton>
                                                    </Cell>
                                                </TableRow>
                                            ))}
                                            {/* Total Row */}
                                            <TableRow
                                                sx={{
                                                    bgcolor: '#DFF0D8', // light green background for total
                                                    fontWeight: 'bold',
                                                }}
                                            >
                                                <Cell colSpan={4} sx={{ textAlign: 'right', fontWeight: 'bold' }}>Total Discount</Cell>
                                                <Cell sx={{ fontWeight: 'bold', width: '10%' }}>
                                                    {rows.reduce((acc, row) => acc + (parseFloat(row.discount) || 0), 0).toFixed(2)}

                                                    {/* { parseFloat(rows?.[0]?.total).toFixed(2)} */}
                                                </Cell>
                                                <Cell colSpan={2} />
                                            </TableRow>
                                        </>
                                    ) : (
                                        <TableRow>
                                            <Cell
                                                colSpan={11}
                                                sx={{
                                                    textAlign: "center",
                                                    fontWeight: "bold",
                                                    fontFamily: FontFamily.NunitoRegular,
                                                    fontSize: "16px",
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        height: "100%",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                    }}
                                                >
                                                    No Data Found
                                                </Box>
                                            </Cell>
                                        </TableRow>
                                    )}
                                </TableBody>

                            </Table>
                        </TableContainer>
                    </Box>
                </Grid>
                {/* Notes */}
                <Grid item md={11} mt={1}>
                    <Grid item md={4}>
                        <InputField
                            label={"Add Notes"}
                            multiline
                            // rows={1}
                            placeholder={"Notes"}
                            value={formData.notes ?? ""}
                            onInput={(e) => setFormData(prev => ({ ...prev, notes: e.target.value }))}
                        />
                    </Grid>
                </Grid>

                {/* Submit Button */}
                <Grid item md={11} justifyContent="end">
                    <Box
                        sx={{
                            mt: "28px",
                            mb: "28px",
                            display: "flex",
                            justifyContent: "flex-end",
                        }}
                    >
                        <PrimaryButton onClick={UpdateSpecialDiscount} title="Update" loading={loading}
                        />
                    </Box>
                </Grid>
            </Grid>
        </Fragment>
    );
};

export default UpdateSpecialDiscount;